import Vue from "vue";

const ApiService = require("../../services/ApiService");

export default Vue.component("order-history", {

    delimiters: ["${", "}"],

    props: {
        template:
        {
            type: String,
            default: "#vue-order-history"
        },
        orderDetailsTemplate:
        {
            type: String,
            default: "Ceres::Checkout.OrderDetails"
        }
    },

    data()
    {
        return {
            currentOrder: null,
            isLoading: false
        };
    },

    methods:
    {
        setCurrentOrder(order)
        {
            $("#dynamic-twig-content").html("");
            this.isLoading = true;
            this.currentOrder = order;

            Vue.nextTick(() =>
            {
                $(this.$refs.orderDetails).modal("show");
            });

            const allowedScriptPaymentMethodIds = [6000]
            const paymentMethodId = order.order.properties.find(p => p.typeId = 3)?.value;
            let executeScript = false;
            if(paymentMethodId && parseInt(paymentMethodId)){
                executeScript = allowedScriptPaymentMethodIds.includes(parseInt(paymentMethodId))
            }

            ApiService
                .get("/rest/io/order/template?template=" + this.orderDetailsTemplate + "&orderId=" + order.order.id)
                .done(response =>
                {
                    this.isLoading = false;
                    $("#dynamic-twig-content").html(response);

                    function unescapeHtml(html) {
                        var el = document.createElement('div');
                        return html.replace(/\&[#0-9a-z]+;/gi, function (enc) {
                            el.innerHTML = enc;
                            return el.innerText
                        });
                    }

                    if(executeScript) {
                        document.querySelectorAll('#dynamic-twig-content script2').forEach(e => {
                            var script = document.createElement("script");
                            script.text = unescapeHtml(e.innerHTML);
                            e.parentNode.replaceChild(script, e)
                        })
                    }
                });
        }
    }
});
